import { createSelector } from '@reduxjs/toolkit';
import { PRICE_SELECTED } from 'pu-data/QuoteSteps';

export const selectAssemblyQuantities = (state) => state.assembly?.parameters?.quantities;
export const selectRowSelected = (state) => state.assembly?.parameters?.row_selected;
export const selectQuoteStep = (state) => state.assembly?.quoteStep;

export const selectAssemblySelectedQuantity = createSelector([
  selectAssemblyQuantities,
  selectRowSelected,
  selectQuoteStep,
], (quantities, row_selected, quoteStep,) => {
  const default_quantity = quantities && quantities.length > 0 ? quantities[0] : null;
  if (!quoteStep || quoteStep !== PRICE_SELECTED) return default_quantity;

  return row_selected && default_quantity ? quantities[row_selected] : default_quantity;
}
)